import { DTEP2dTableConfigBlockState } from './types';

const defaultState: DTEP2dTableConfigBlockState = {
    settings: {
        fontSize: 100,
        displayTableHeading: true,
        timeLocale: 'en-gb',
        timeRange: 'PT0S--PT0S',
        labelDatabilities: [],
    },
    databilities: [],
};

export default defaultState;
